module.exports = __webpack_public_path__ + "static/media/next.c4dce839.svg";